// src/api/commentApi.js
// 댓글 관련 API 모듈

import api from './axios';

/* ── 목록 / 조회 ────────────────────────────────────────────── */
// 댓글 목록 조회
export const fetchComments = (postId) =>
  api.get(`/api/comments/posts/${postId}/`)
    .catch(err => {
      console.error('댓글 조회 실패:', err);
      throw err;
    });

/* ── 작성 ─────────────────────────────────────────────────── */
// 댓글 작성
export const addComment = (postId, content) =>
  api.post(`/api/comments/posts/${postId}/add/`, { content })
    .catch(err => {
      console.error('댓글 추가 실패:', err);
      throw err;
    });

// 대댓글 작성
export const replyToComment = (postId, commentId, content) =>
  api.post(`/api/comments/posts/${postId}/comments/${commentId}/reply/`, { content })
    .catch(err => {
      console.error('대댓글 작성 실패:', err);
      throw err;
    });

/* ── 수정 ─────────────────────────────────────────────────── */
// 댓글 수정
export const updateComment = (commentId, content) =>
  api.put(`/api/comments/${commentId}/update/`, { content })
    .catch(err => {
      console.error('댓글 수정 실패:', err);
      throw err;
    });

/* ── 삭제 ─────────────────────────────────────────────────── */
// 작성자용 소프트 삭제 (POST)
export const softDeleteComment = (commentId, memo = '') =>
  api.post(`/api/comments/${commentId}/soft-delete/`, { memo })
    .catch(err => {
      console.error('댓글 소프트 삭제 실패:', err);
      throw err;
    });

// 운영자용 영구 삭제 (DELETE + body → axios.delete 2번째 인자에 { data } 전달)
export const permanentDeleteComment = (commentId, memo = '') =>
  api.delete(`/api/comments/${commentId}/permanent-delete/`, { data: { memo } })
    .catch(err => {
      console.error('댓글 영구 삭제 실패:', err);
      throw err;
    });

/* ── 좋아요 ───────────────────────────────────────────────── */
// 댓글 좋아요 토글
export const toggleCommentLike = (commentId) =>
  api.post(`/api/comments/${commentId}/toggle-like/`)
    .catch(err => {
      console.error('댓글 좋아요 실패:', err);
      throw err;
    });
